var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,12A1.5,1.5,0,1,1,6,10.5,1.5,1.5,0,0,1,7.5,12ZM12,10.5A1.5,1.5,0,1,0,13.5,12,1.5,1.5,0,0,0,12,10.5Zm6,0A1.5,1.5,0,1,0,19.5,12,1.5,1.5,0,0,0,18,10.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/1762842647/media/icon-more.bf823a35e63b6ad263983853eb95547d.svg";
export { ForwardRef as ReactComponent };